import { NotFound as NF } from "@/components/emptyPlaceholders/NotFound/NotFound";
import NFIcon from "@/assets/icons/common/raisins.svg?react";

export function NotFound() {
  return <NF title="Страница не найдена" icon={<NFIcon />} />;
}
